// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"7b6e1828","993":"7098d293"}[chunkId] + ".chunk.css";
};